export const cashdesk = {
  seo: {
    title: 'Cashdesk integration | Bistroo',
    description: 'Connect Cashdesk POS to Bistroo. Online orders automatically arrive as POS receipts — set up in 20 minutes.',
  },
  hero: {
    category: 'POS system',
    description: 'Connect Cashdesk to Bistroo and receive online orders directly as POS receipts — easy to set up, always reliable.',
  },
  about: {
    title: 'What does Cashdesk do?',
    p1: 'Cashdesk is a user-friendly POS system for the restaurant industry and retail. It offers everything you need: a fast touchscreen interface, multiple payment methods, staff management and daily reports. Cashdesk is modularly built so it perfectly suits your specific situation.',
    p2: 'With the Bistroo × Cashdesk connection, online orders are automatically processed in your POS. Your staff sees the order on the POS screen and the kitchen printer prints immediately — exactly like a regular table transaction, but entirely online.',
    benefits_title: 'What does the connection deliver?',
    benefits: [
      'Automatic POS receipt for every online order',
      'Direct routing to kitchen and bar printers',
      'Product options and allergen info visible on receipt',
      'Online and offline revenue combined in daily report',
      'Set up in 20 minutes, no technical knowledge needed',
    ],
  },
  wordcloud_title: 'Cashdesk at a glance',
  wordcloud: ['POS software', 'Hospitality POS', 'Touchscreen', 'Kitchen print', 'Receipt print', 'Day close', 'API integration', 'Automatic', 'Branch', 'Multiple locations', 'Menu', 'Order processing', 'Daily report', 'Quick POS', 'Hospitality'],
  usp: {
    heading: 'Why connect Bistroo to Cashdesk?',
    items: [
      { icon: 'bi-stopwatch-fill', title: 'Live in 20 minutes', text: 'The Cashdesk connection is straightforward to set up. No technical knowledge needed — within twenty minutes you are receiving your first online order in the POS.' },
      { icon: 'bi-check2-all', title: 'Zero manual work', text: 'Every Bistroo order is automatically processed in Cashdesk. Your team focuses on preparing and serving, not on retyping.' },
      { icon: 'bi-printer-fill', title: 'Instant kitchen print', text: 'The receipt prints directly on the correct printer as soon as the order comes in. Product options and allergens are always visible.' },
      { icon: 'bi-bar-chart-steps', title: 'Combined reporting', text: 'Online and offline revenue combined in one Cashdesk daily report. Always a complete picture of your performance.' },
      { icon: 'bi-list-ul', title: 'Menu always in sync', text: 'Import your Cashdesk product list as a starting point for your Bistroo menu. Price and product changes are managed centrally and immediately visible in your webshop.' },
      { icon: 'bi-shield-check', title: 'Allergens always correct', text: 'Product options, variants and allergen information are transferred flawlessly and always visible on the receipt.' },
    ],
  },
  setup: {
    heading: 'How to connect Cashdesk to Bistroo',
    steps: [
      'Open the Cashdesk management portal and activate the API integration via Settings.',
      'Copy your Cashdesk API key and location ID.',
      'Go to Bistroo Merchant Portal → Integrations → Cashdesk.',
      'Enter the API key and location ID and save the connection.',
      'Process a test order to confirm the integration.',
    ],
  },
  faq: {
    items: [
      { q: 'Does the connection work with all Cashdesk packages?', a: 'The integration works with Cashdesk Professional and Enterprise. Check with Cashdesk whether your subscription includes API access; this is standard for paid packages.' },
      { q: 'Are product options passed on correctly?', a: 'Yes. All variants, extras and special requests that customers provide are displayed as detailed instructions on the POS receipt.' },
      { q: 'How do I manage my menu in Cashdesk for Bistroo?', a: 'You can import your existing Cashdesk product list as a starting point for your Bistroo menu. Adjustments for your webshop (photos, descriptions, time windows) are managed in Bistroo.' },
      { q: 'Can I set up multiple printers?', a: 'Yes. Via Cashdesk you configure per product category which printer a receipt goes to. This way cold drinks go to the bar and hot meals to the kitchen.' },
      { q: 'What does the Cashdesk integration cost?', a: 'The Bistroo connection is included in your Bistroo subscription. Cashdesk may charge for API usage; check their website for current rates.' },
    ],
  },
}
